import React from 'react'
import _ from 'lodash'
import moment from 'moment'

import {Row, Col} from 'react-flexbox-grid'

import {Form, Input, Submit, Select, Reset} from 'forms'

import {TokenService} from 'api/tokens'

const convertExpirey = ({expires, usage_time, ...rest}) => {
   let newExpires = moment().add(expires).toISOString()

   if (undefined === usage_time) {
      return _.merge(rest, {expires: newExpires})
   } else {
      return _.merge(rest, {expires: newExpires, usage_time: parseInt(expires, 10)})
   }
}

export class CreateToken extends React.Component {
   constructor() {
      super()
   }

   handleSubmit(ev, data) {
      return TokenService.create(data)
   }

   render() {
      const expirationOpts = [
         {label: 'A Year', value: 86400 * 365 * 1000},
         {label: 'Half Year', value: 86400 * 182 * 1000},
         {label: 'Three Months', value: 86400 * 90 * 1000},
         {label: 'One Month', value: 86400 * 30 * 1000},
         {label: 'A Week', value: 86400 * 7 * 1000},
         {label: 'Day', value: 86400 * 1000},
         {label: 'Never', value: -1}
      ]

      return (
         <div className="userauth new-token">
            <div className="page-header">
               <h1>Create Token</h1>
            </div>

            <Form
               transform={convertExpirey}
               onSubmit={this.handleSubmit}
               defaultValues={{expires: 86400 * 30 * 1000}}
               input={{}}
            >

               <Form.Error>
                  Some error occured
               </Form.Error>

               <Form.Updated>
                  Token Created!!
               </Form.Updated>

               <Row>
                  <Col xs={6}>
                     <Input param="name" label="Token Name" validate={{size: 48}} type="text" />
                  </Col>

                  <Col xs={6}>
                     <Input param="usage_time" label="Extend Expiry on usage" type="checkbox" />
                  </Col>

                  <Col xs={12}>
                     <Select param="expires" label="Token Expiration" options={expirationOpts} />
                  </Col>
               </Row>

               <Row>
                  <Col xs={12}>
                     <Submit>Create Token</Submit>
                     <Reset>Reset Form</Reset>
                  </Col>
               </Row>
            </Form>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/user/CreateToken.jsx